import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '@/App.css';
import { FaShoppingCart, FaUser, FaWhatsapp, FaGlobe, FaBars, FaTimes } from 'react-icons/fa';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Rental from './pages/Rental';
import RentalDetail from './pages/RentalDetail';
import RentalConversation from './pages/RentalConversation';
import RentalConversations from './pages/RentalConversations';
import Stores from './pages/Stores';
import Directory from './pages/Directory';
import DirectoryMain from './pages/directory/DirectoryMain';
import DirectoryFamily from './pages/directory/DirectoryFamily';
import DirectoryCategory from './pages/directory/DirectoryCategory';
import CompanyProfile from './pages/directory/CompanyProfile';
import DirectoryCategoryOrCompany from './pages/directory/DirectoryCategoryOrCompany';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminCategories from './pages/admin/Categories';
import AdminOrders from './pages/admin/Orders';
import AdminRentals from './pages/admin/Rentals';
import RentalApprovals from './pages/admin/RentalApprovals';
import AdminRentalMessages from './pages/admin/RentalMessages';
import AdminReviews from './pages/admin/Reviews';
import AdminShops from './pages/admin/Shops';
import AdminRevenues from './pages/admin/Revenues';
import ProductApprovals from './pages/admin/ProductApprovals';
import AdminDirectory from './pages/admin/Directory';
import AdminModeration from './pages/admin/Moderation';
import AdminUsers from './pages/admin/Users';
import AdminBanners from './pages/admin/Banners';
import AdminUserHistory from './pages/admin/UserHistory';
import AdminQuoteRequests from './pages/admin/QuoteRequests';
import RequestApprovals from './pages/admin/RequestApprovals';
import RequestsManagement from './pages/admin/RequestsManagement';
import UserApprovals from './pages/admin/UserApprovals';
import UsersManagement from './pages/admin/UsersManagement';
import AdminDirectoryCategories from './pages/admin/DirectoryCategories';
import AdminDirectoryPending from './pages/admin/DirectoryPending';
import AdminDirectoryManagement from './pages/admin/DirectoryManagement';
import DirectoryImport from './pages/admin/DirectoryImport';
import ContentViolations from './pages/admin/ContentViolations';
import SubscriptionManagement from './pages/admin/SubscriptionManagement';
import AdminTalents from './pages/admin/AdminTalents';
import AdminComparator from './pages/admin/AdminComparator';
import AdminTemplates from './pages/admin/Templates';
import TemplateFields from './pages/admin/TemplateFields';
import AdminComparatorSpecs from './pages/admin/AdminComparatorSpecs';
import DemandesDashboard from './pages/admin/DemandesDashboard';
import AdminAnnonces from './pages/admin/AdminAnnonces';
import AdminStats from './pages/admin/AdminStats';
import Pricing from './pages/Pricing';
import Tarifs from './pages/Tarifs';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import HomeV2 from './pages/HomeV2';
import VendreMateriel from './pages/VendreMateriel';
import LouerMateriel from './pages/LouerMateriel';
import ServiceTechnique from './pages/ServiceTechnique';
import EtudeGeotechnique from './pages/EtudeGeotechnique';
import TravauxFondations from './pages/TravauxFondations';
import Recrutement from './pages/Recrutement';
import MySubscription from './pages/user/MySubscription';
import AllConversations from './pages/user/AllConversations';
import MyAnnonce from './pages/user/MyAnnonce';
import MyAnnonces from './pages/user/MyAnnonces';
import DirectorySubmit from './pages/DirectorySubmit';
import UserDashboard from './pages/user/Dashboard';
// Subscription system removed - roles managed by admin
// import UserSubscription from './pages/user/Subscription';
import MyListings from './pages/user/MyListings';
import MyInvoices from './pages/user/MyInvoices';
import MyOrders from './pages/user/MyOrders';
import UserOrderDetail from './pages/user/UserOrderDetail';
import MyRentals from './pages/user/MyRentals';
import Requests from './pages/Requests';
import RequestDetail from './pages/RequestDetail';
import RequestConversation from './pages/RequestConversation';
import MyRequests from './pages/user/MyRequests';
import MyProjects from './pages/user/MyProjects';
import ProjectDetail from './pages/user/ProjectDetail';
import MyProposals from './pages/user/MyProposals';
import SupplierOpportunities from './pages/supplier/Opportunities';
import SubmitQuote from './pages/supplier/SubmitQuote';
import MyQuotes from './pages/supplier/MyQuotes';
import SupplierMyProducts from './pages/supplier/MyProducts';
import MyRentalListings from './pages/supplier/MyRentalListings';
import RentalRequests from './pages/supplier/RentalRequests';
import ProductQuoteRequests from './pages/supplier/ProductQuoteRequests';
import SupplierQuoteThread from './pages/supplier/QuoteThread';
import SupplierOrders from './pages/supplier/SupplierOrders';
import SupplierOrderDetail from './pages/supplier/SupplierOrderDetail';
import SupplierInvoices from './pages/supplier/SupplierInvoices';
import ProjectRFQ from './pages/supplier/ProjectRFQ';
import ProposalThread from './pages/user/ProposalThread';
import UserVerification from './pages/user/UserVerification';
import SecurityDashboard from './pages/admin/SecurityDashboard';
import Suppliers from './pages/Suppliers';
import ShopCategory from './pages/shop/ShopCategory';
import Talents from './pages/Talents';
import TalentDetail from './pages/TalentDetail';
import TalentPublish from './pages/TalentPublish';
import MyTalentAds from './pages/user/MyTalentAds';
import ProductConversation from './pages/ProductConversation';
import Comparator from './pages/Comparator';
import ValueBanner from './components/ValueBanner';
import NotificationBell from './components/NotificationBell';
import Footer from './components/Footer';
import CookieConsentBanner from './components/CookieConsentBanner';
import ComparatorFloatingBar from './components/ComparatorFloatingBar';
import ComparatorCategoryErrorModal from './components/ComparatorCategoryErrorModal';
import { ComparatorProvider } from './context/ComparatorContext';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import CookiePolicy from './pages/CookiePolicy';
import HowItWorks from './pages/HowItWorks';

// Enchères Module (Courtage aux enchères) - NEW ISOLATED MODULE
import EncheresHub from './pages/encheres/EncheresHub';
import VacationPage from './pages/encheres/VacationPage';
import LotPage from './pages/encheres/LotPage';
import EncheresConditions from './pages/encheres/Conditions';
import DevenirVendeur from './pages/encheres/DevenirVendeur';
import EncheresConnexion from './pages/encheres/Connexion';
import MonCompteAcheteur from './pages/encheres/MonCompteAcheteur';
import InscriptionVacation from './pages/encheres/InscriptionVacation';
import EspaceVendeur from './pages/encheres/EspaceVendeur';
import AdminEncheres from './pages/admin/AdminEncheres';

import HowToChooseDrilling from './pages/Guides/HowToChooseDrilling';
import HowToChooseGeotechnicalStudy from './pages/Guides/HowToChooseGeotechnicalStudy';
import HowToChooseSpecialFoundations from './pages/Guides/HowToChooseSpecialFoundations';
import SlurryWallGuide from './pages/Guides/SlurryWallGuide';
import DrillingEquipmentGuide from './pages/Guides/DrillingEquipmentGuide';
import HouseCracksGuide from './pages/Guides/HouseCracksGuide';
import DrillParameterRecorderGuide from './pages/Guides/DrillParameterRecorderGuide';
import MicropieuxGuide from './pages/Guides/MicropieuxGuide';
import PressiometricTestGuide from './pages/Guides/PressiometricTestGuide';
import InjectionGuide from './pages/Guides/InjectionGuide';
import ForeuseOccasionMicropieuxGuide from './pages/Guides/ForeuseOccasionMicropieuxGuide';
import PressiometreChoixGuide from './pages/Guides/PressiometreChoixGuide';
import MetierForeurSondeurGuide from './pages/Guides/MetierForeurSondeurGuide';
import PrixForageEauGuide from './pages/Guides/PrixForageEauGuide';
import EtalonnageCapteurs from './pages/Guides/EtalonnageCapteurs';
import EtalonnageInstrumentation from './pages/Directory/EtalonnageInstrumentation';
import ForageEauDemande from './pages/ForageEauDemande';
import DemandeVisite from './pages/DemandeVisite';
import MaterielDemande from './pages/MaterielDemande';
import GuidesIndex from './pages/Guides/GuidesIndex';
import GuideCategoryPage from './pages/Guides/GuideCategoryPage';
import CalculsIndex from './pages/Calculs/CalculsIndex';
import PortanceMicropieu from './pages/Calculs/PortanceMicropieu';
import EstimerForeuse from './pages/Calculs/EstimerForeuse';
import PrixEtudeSol from './pages/Calculs/PrixEtudeSol';
import About from './pages/About';
import Commissions from './pages/Commissions';
import Inscription from './pages/Inscription';
import MonCompte from './pages/MonCompte';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AppContext = React.createContext();

// Component to show pending approval banner
const PendingApprovalBanner = ({ user }) => {
  if (!user || user.account_status !== 'pending') return null;
  
  return (
    <div className="bg-yellow-500 text-white px-4 py-3 text-center">
      <p className="text-sm font-medium">
        ⏳ Votre compte est en attente d&apos;approbation. Certaines fonctionnalités sont limitées.
      </p>
    </div>
  );
};

function App() {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to check if user has a specific role
  const hasRole = (roleToCheck) => {
    if (!user) return false;
    const userRoles = user.roles || [user.role];
    return userRoles.includes(roleToCheck);
  };

  // Helper function to check if account is approved
  const isAccountApproved = () => {
    if (!user) return false;
    // If account_status is not set (existing users), consider them approved
    return user.account_status === 'approved' || !user.account_status;
  };

  // Helper function to check if user can perform actions (approved accounts only)
  const canPerformActions = () => {
    return user && isAccountApproved();
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      const parsedUser = JSON.parse(savedUser);
      setUser(parsedUser);
      
      // Refresh user data from server to get latest account_status
      refreshUserData(parsedUser.id);
    }
    
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
    setIsLoading(false); // Mark initialization as complete
  }, []);

  // Function to refresh user data from server
  const refreshUserData = async (userId) => {
    const token = localStorage.getItem('token');
    if (!token || !userId) return;
    
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data) {
        const updatedUser = response.data;
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }
    } catch (error) {
      console.log('Could not refresh user data:', error.message);
    }
  };

  // Login function to set user and token
  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  };

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const toggleLanguage = () => {
    // Get current language (first 2 chars only)
    const currentLang = i18n.language?.substring(0, 2).toLowerCase() || 'fr';
    const newLang = currentLang === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const addToCart = (product, type, quantity = 1) => {
    const existingItem = cart.find(item => item.product.id === product.id && item.type === type);
    
    if (existingItem) {
      setCart(cart.map(item => 
        item.product.id === product.id && item.type === type
          ? { ...item, quantity: item.quantity + quantity }
          : item
      ));
    } else {
      setCart([...cart, { product, type, quantity }]);
    }
  };

  const removeFromCart = (productId, type) => {
    setCart(cart.filter(item => !(item.product.id === productId && item.type === type)));
  };

  const updateCartQuantity = (productId, type, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId, type);
    } else {
      setCart(cart.map(item =>
        item.product.id === productId && item.type === type
          ? { ...item, quantity }
          : item
      ));
    }
  };

  const clearCart = () => {
    setCart([]);
  };

  const cartTotal = cart.reduce((sum, item) => {
    const price = item.type === 'new' ? item.product.price_new :
                  item.type === 'used' ? item.product.price_used :
                  item.product.price_rental;
    return sum + (price * item.quantity);
  }, 0);

  return (
    <AppContext.Provider value={{ 
      user, 
      setUser,
      login,
      logout,
      cart, 
      addToCart, 
      removeFromCart, 
      updateCartQuantity,
      clearCart,
      cartTotal,
      API,
      BACKEND_URL,
      isAccountApproved,
      canPerformActions,
    }}>
      <ComparatorProvider>
      <BrowserRouter>
        <div className="App">
          {/* Pending Approval Banner */}
          <PendingApprovalBanner user={user} />
          
          {/* Header - Modern Stripe-like */}
          <header className="glass sticky top-0 z-50 border-b border-gray-100">
            <div className="container mx-auto px-4 py-3">
              <div className="flex justify-between items-center">
                {/* Logo */}
                <Link to="/" className="flex items-center space-x-2 group">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#635BFF] to-[#00D4FF] flex items-center justify-center">
                    <span className="text-white font-bold text-lg">G</span>
                  </div>
                  <span className="text-xl font-bold text-[#0A2540] group-hover:text-[#635BFF] transition-colors">
                    GEOTS<span className="text-[#635BFF]">.consulting</span>
                  </span>
                </Link>

                {/* Desktop Navigation - visible only on large screens */}
                <nav className="hidden lg:flex items-center space-x-1 xl:space-x-2">
                  <Link to="/" className="px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-home">
                    {t('nav.home')}
                  </Link>
                  <Link to="/shop" className="px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-shop">
                    {t('nav.shop')}
                  </Link>
                  <Link to="/suppliers" className="px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-suppliers">
                    {i18n.language === 'fr' ? 'Fournisseurs' : 'Suppliers'}
                  </Link>
                  <Link to="/directory" className="px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-directory">
                    {t('nav.directory')}
                  </Link>
                  <Link to="/requests" className="px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-requests">
                    {i18n.language === 'fr' ? 'Demandes' : 'Requests'}
                  </Link>
                  <Link to="/encheres" className="px-3 py-2 rounded-lg hover:bg-[#F0A22E]/10 text-[#F0A22E] transition-all font-semibold text-sm" data-testid="nav-encheres">
                    {i18n.language === 'fr' ? 'Enchères' : 'Auctions'}
                  </Link>
                  <Link to="/talents" className="px-3 py-2 rounded-lg hover:bg-[#00D4FF]/10 text-[#00D4FF] transition-all font-semibold text-sm" data-testid="nav-talents">
                    {i18n.language === 'fr' ? 'Talents' : 'Talents'}
                  </Link>
                  <Link to="/comparateur" className="px-3 py-2 rounded-lg hover:bg-[#0A2540]/10 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-comparator">
                    {i18n.language === 'fr' ? 'Comparateur' : 'Comparator'}
                  </Link>
                  <Link to="/guides" className="px-3 py-2 rounded-lg hover:bg-[#0A2540]/10 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-guides">
                    {i18n.language === 'fr' ? 'Guides' : 'Guides'}
                  </Link>
                  <Link to="/calcul" className="px-3 py-2 rounded-lg hover:bg-[#0A2540]/10 text-[#0A2540] transition-all font-medium text-sm" data-testid="nav-calculs">
                    {i18n.language === 'fr' ? 'Calculs' : 'Calculators'}
                  </Link>
                  <Link to="/pricing" className="px-3 py-2 rounded-lg bg-[#635BFF]/10 text-[#635BFF] hover:bg-[#635BFF]/20 transition-all font-semibold text-sm" data-testid="nav-pricing">
                    {i18n.language === 'fr' ? 'Tarifs' : 'Pricing'}
                  </Link>
                  
                  {(hasRole('supplier') || hasRole('admin')) && (
                    <>
                      <div className="w-px h-6 bg-gray-200 mx-1"></div>
                      <div className="relative group">
                        <button className="px-3 py-2 rounded-lg bg-[#635BFF]/10 text-[#635BFF] hover:bg-[#635BFF]/20 transition-all font-semibold text-sm flex items-center gap-1">
                          {i18n.language === 'fr' ? '🏢 Espace Pro' : '🏢 Pro Space'}
                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                        </button>
                        <div className="absolute top-full left-0 mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                          <div className="py-2">
                            <Link to="/supplier/opportunities" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-[#635BFF]/5 hover:text-[#635BFF]">
                              🏭 {i18n.language === 'fr' ? 'Chantiers' : 'Projects'}
                            </Link>
                            <Link to="/supplier/my-products" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-[#635BFF]/5 hover:text-[#635BFF]">
                              📦 {i18n.language === 'fr' ? 'Produits' : 'Products'}
                            </Link>
                            <Link to="/supplier/product-quote-requests" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-[#635BFF]/5 hover:text-[#635BFF]">
                              📩 {i18n.language === 'fr' ? 'Devis' : 'Quotes'}
                            </Link>
                            <Link to="/supplier/rental-requests" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-[#00D4FF]/5 hover:text-[#00D4FF]">
                              📅 {i18n.language === 'fr' ? 'Locations' : 'Rentals'}
                            </Link>
                            <Link to="/supplier/orders" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                              🛒 {i18n.language === 'fr' ? 'Commandes' : 'Orders'}
                            </Link>
                            <Link to="/supplier/invoices" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600">
                              📄 {i18n.language === 'fr' ? 'Factures' : 'Invoices'}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  
                  {hasRole('admin') && (
                    <Link to="/admin" className="px-3 py-2 rounded-lg hover:bg-purple-50 text-purple-600 transition-all font-semibold text-sm" data-testid="nav-admin">
                      {t('nav.admin')}
                    </Link>
                  )}
                </nav>

                {/* Actions - visible only on large screens */}
                <div className="hidden lg:flex items-center space-x-3">
                  <button 
                    onClick={toggleLanguage} 
                    className="flex items-center space-x-1 px-3 py-2 rounded-lg hover:bg-gray-100 text-[#0A2540] transition-all text-sm"
                    data-testid="language-toggle"
                  >
                    <FaGlobe className="text-gray-500" />
                    <span className="font-medium">{i18n.language?.substring(0, 2).toUpperCase() || 'FR'}</span>
                  </button>
                  
                  {user && <NotificationBell />}
                  
                  <Link to="/cart" className="relative p-2 rounded-lg hover:bg-gray-100 transition-all" data-testid="nav-cart">
                    <FaShoppingCart className="text-xl text-[#0A2540]" />
                    {cart.length > 0 && (
                      <span className="absolute -top-1 -right-1 bg-[#635BFF] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium" data-testid="cart-count">
                        {cart.length}
                      </span>
                    )}
                  </Link>
                  
                  {user ? (
                    <div className="relative group">
                      <button className="flex items-center gap-1 p-2 rounded-lg hover:bg-gray-100 transition-all">
                        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#635BFF] to-[#00D4FF] flex items-center justify-center">
                          <span className="text-white text-sm font-bold">{user.name?.charAt(0).toUpperCase()}</span>
                        </div>
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                      </button>
                      {/* User Dropdown Menu */}
                      <div className="absolute top-full right-0 mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                        <div className="py-2">
                          {(hasRole('decouverte') || hasRole('pro')) && !hasRole('supplier') && (
                            <Link to="/user/mes-annonces" className="flex items-center gap-2 px-4 py-2 text-sm text-[#635BFF] hover:bg-[#635BFF]/5 font-medium">
                              📦 {i18n.language === 'fr' ? 'Mes Annonces' : 'My Ads'}
                            </Link>
                          )}
                          <Link to="/user/rentals" className="flex items-center gap-2 px-4 py-2 text-sm text-[#00D4FF] hover:bg-[#00D4FF]/5 font-medium">
                            📅 {i18n.language === 'fr' ? 'Mes Locations' : 'My Rentals'}
                          </Link>
                          <Link to="/user/orders" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                            🛒 {i18n.language === 'fr' ? 'Commandes' : 'Orders'}
                          </Link>
                          <Link to="/user/conversations" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                            💬 Messages
                          </Link>
                          <Link to="/user/dashboard" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                            <FaUser className="text-xs" /> {i18n.language === 'fr' ? 'Profil' : 'Profile'}
                          </Link>
                          {/* Enchères Links */}
                          {user.roles?.includes('enchere_acheteur') && (
                            <Link to="/encheres/mon-compte" className="flex items-center gap-2 px-4 py-2 text-sm text-[#F0A22E] hover:bg-[#F0A22E]/5 font-medium">
                              🔨 {i18n.language === 'fr' ? 'Espace Acheteur' : 'Buyer Space'}
                            </Link>
                          )}
                          {user.roles?.includes('enchere_vendeur') && (
                            <Link to="/encheres/espace-vendeur" className="flex items-center gap-2 px-4 py-2 text-sm text-[#F0A22E] hover:bg-[#F0A22E]/5 font-medium">
                              🏷️ {i18n.language === 'fr' ? 'Espace Vendeur' : 'Seller Space'}
                            </Link>
                          )}
                          <Link to="/user/verification" className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                            🔒 {i18n.language === 'fr' ? 'Vérification' : 'Verification'}
                          </Link>
                          <Link to="/user/mes-annonces-talents" className="flex items-center gap-2 px-4 py-2 text-sm text-[#00D4FF] hover:bg-[#00D4FF]/5">
                            👷 {i18n.language === 'fr' ? 'Mes Talents' : 'My Talents'}
                          </Link>
                          <div className="border-t my-1"></div>
                          <button 
                            onClick={logout}
                            className="flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full"
                          >
                            🚪 {i18n.language === 'fr' ? 'Déconnexion' : 'Logout'}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Link to="/login" data-testid="nav-login">
                      <button className="btn-gradient text-white text-sm py-2 px-5 rounded-lg font-medium">
                        {t('nav.login')}
                      </button>
                    </Link>
                  )}
                </div>

                {/* Mobile & Tablet Actions */}
                <div className="lg:hidden flex items-center space-x-3">
                  {/* Notification Bell - Mobile */}
                  {user && <NotificationBell />}
                  
                  {/* Cart - Mobile */}
                  <Link to="/cart" className="relative p-2" data-testid="nav-cart-mobile">
                    <FaShoppingCart className="text-xl text-[#0A2540]" />
                    {cart.length > 0 && (
                      <span className="absolute -top-1 -right-1 bg-[#635BFF] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium" data-testid="cart-count-mobile">
                        {cart.length}
                      </span>
                    )}
                  </Link>
                  
                  {/* Mobile Menu Button */}
                  <button 
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center text-[#0A2540]"
                    data-testid="mobile-menu-toggle"
                  >
                    {mobileMenuOpen ? <FaTimes /> : <FaBars />}
                  </button>
                </div>
              </div>

              {/* Mobile & Tablet Menu - Full Screen Overlay */}
              {mobileMenuOpen && (
                <div className="lg:hidden fixed top-0 left-0 right-0 bottom-0 w-full h-screen bg-white overflow-y-auto" style={{zIndex: 99999}} data-testid="mobile-menu">
                  {/* Header with close button */}
                  <div className="sticky top-0 bg-white border-b border-gray-100 px-4 py-4 flex justify-between items-center">
                    <Link to="/" onClick={() => setMobileMenuOpen(false)} className="flex items-center space-x-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#635BFF] to-[#00D4FF] flex items-center justify-center">
                        <span className="text-white font-bold">G</span>
                      </div>
                      <span className="font-bold text-[#0A2540]">GEOTS<span className="text-[#635BFF]">.consulting</span></span>
                    </Link>
                    <div className="flex items-center gap-2">
                      {/* Language Toggle - Mobile Header */}
                      <button 
                        onClick={toggleLanguage} 
                        className="flex items-center gap-1 bg-gray-100 px-3 py-2 rounded-lg text-sm font-medium"
                      >
                        <FaGlobe className="text-gray-500" />
                        {i18n.language?.substring(0, 2).toUpperCase() || 'FR'}
                      </button>
                      <button onClick={() => setMobileMenuOpen(false)} className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
                        <FaTimes className="text-[#0A2540]" />
                      </button>
                    </div>
                  </div>
                  
                  <nav className="px-4 py-6">
                    {/* Navigation principale */}
                    <div className="grid grid-cols-2 gap-3 mb-6">
                      <Link to="/" onClick={() => setMobileMenuOpen(false)} className="bg-gray-50 rounded-xl p-4 text-center hover:bg-gray-100 transition-colors">
                        <span className="text-2xl mb-1 block">🏠</span>
                        <span className="text-sm font-medium text-[#0A2540]">{t('nav.home')}</span>
                      </Link>
                      <Link to="/shop" onClick={() => setMobileMenuOpen(false)} className="bg-gray-50 rounded-xl p-4 text-center hover:bg-gray-100 transition-colors">
                        <span className="text-2xl mb-1 block">🛍️</span>
                        <span className="text-sm font-medium text-[#0A2540]">{t('nav.shop')}</span>
                      </Link>
                      <Link to="/suppliers" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/10 rounded-xl p-4 text-center hover:bg-[#635BFF]/20 transition-colors">
                        <span className="text-2xl mb-1 block">🏭</span>
                        <span className="text-sm font-medium text-[#635BFF]">{i18n.language === 'fr' ? 'Fournisseurs' : 'Suppliers'}</span>
                      </Link>
                      <Link to="/directory" onClick={() => setMobileMenuOpen(false)} className="bg-gray-50 rounded-xl p-4 text-center hover:bg-gray-100 transition-colors">
                        <span className="text-2xl mb-1 block">📖</span>
                        <span className="text-sm font-medium text-[#0A2540]">{t('nav.directory')}</span>
                      </Link>
                      <Link to="/requests" onClick={() => setMobileMenuOpen(false)} className="bg-gray-50 rounded-xl p-4 text-center hover:bg-gray-100 transition-colors">
                        <span className="text-2xl mb-1 block">📝</span>
                        <span className="text-sm font-medium text-[#0A2540]">{i18n.language === 'fr' ? 'Demandes' : 'Requests'}</span>
                      </Link>
                      <Link to="/encheres" onClick={() => setMobileMenuOpen(false)} className="bg-[#F0A22E]/10 rounded-xl p-4 text-center hover:bg-[#F0A22E]/20 transition-colors">
                        <span className="text-2xl mb-1 block">🔨</span>
                        <span className="text-sm font-medium text-[#F0A22E]">{i18n.language === 'fr' ? 'Enchères' : 'Auctions'}</span>
                      </Link>
                      <Link to="/talents" onClick={() => setMobileMenuOpen(false)} className="bg-[#00D4FF]/10 rounded-xl p-4 text-center hover:bg-[#00D4FF]/20 transition-colors">
                        <span className="text-2xl mb-1 block">👷</span>
                        <span className="text-sm font-medium text-[#00D4FF]">{i18n.language === 'fr' ? 'Talents' : 'Talents'}</span>
                      </Link>
                      <Link to="/comparateur" onClick={() => setMobileMenuOpen(false)} className="bg-[#0A2540]/5 rounded-xl p-4 text-center hover:bg-[#0A2540]/10 transition-colors">
                        <span className="text-2xl mb-1 block">⚖️</span>
                        <span className="text-sm font-medium text-[#0A2540]">{i18n.language === 'fr' ? 'Comparateur' : 'Comparator'}</span>
                      </Link>
                      <Link to="/guides" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-xl p-4 text-center hover:bg-[#635BFF]/10 transition-colors">
                        <span className="text-2xl mb-1 block">📚</span>
                        <span className="text-sm font-medium text-[#635BFF]">{i18n.language === 'fr' ? 'Guides' : 'Guides'}</span>
                      </Link>
                      <Link to="/calcul" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-xl p-4 text-center hover:bg-[#635BFF]/10 transition-colors">
                        <span className="text-2xl mb-1 block">🧮</span>
                        <span className="text-sm font-medium text-[#635BFF]">{i18n.language === 'fr' ? 'Calculs' : 'Calculators'}</span>
                      </Link>
                    </div>
                    
                    {/* Pricing CTA */}
                    <Link to="/pricing" onClick={() => setMobileMenuOpen(false)} className="block w-full bg-gradient-to-r from-[#635BFF] to-[#8B7DFF] rounded-xl p-4 text-center mb-4 shadow-lg shadow-[#635BFF]/20">
                      <span className="text-white font-semibold">{i18n.language === 'fr' ? '💰 Voir les Tarifs' : '💰 View Pricing'}</span>
                    </Link>
                    
                    {/* How it works link */}
                    <Link to="/comment-ca-marche" onClick={() => setMobileMenuOpen(false)} className="block w-full bg-[#0A2540] rounded-xl p-4 text-center mb-6">
                      <span className="text-white font-medium">{i18n.language === 'fr' ? '❓ Comment ça marche ?' : '❓ How it works?'}</span>
                    </Link>
                    
                    {user && (
                      <>
                        {/* Mon Compte - Compact */}
                        <div className="border-t border-gray-100 pt-6 mb-4">
                          <p className="text-xs text-gray-500 uppercase mb-3 font-bold">{i18n.language === 'fr' ? 'Mon Compte' : 'My Account'}</p>
                          <div className="grid grid-cols-2 gap-2">
                            <Link to="/user/dashboard" onClick={() => setMobileMenuOpen(false)} className="bg-blue-50 rounded-lg p-3 text-sm flex items-center gap-2">
                              <FaUser className="text-[#0A2540]" /> Mon profil
                            </Link>
                            <Link to="/user/orders" onClick={() => setMobileMenuOpen(false)} className="bg-blue-50 rounded-lg p-3 text-sm flex items-center gap-2">
                              🛒 Commandes
                            </Link>
                            <Link to="/user/rentals" onClick={() => setMobileMenuOpen(false)} className="bg-[#00D4FF]/10 rounded-lg p-3 text-sm flex items-center gap-2 text-[#00D4FF]">
                              📅 Mes Locations
                            </Link>
                            <Link to="/rentals/conversations" onClick={() => setMobileMenuOpen(false)} className="bg-orange-50 rounded-lg p-3 text-sm flex items-center gap-2 text-[#00D4FF]">
                              💬 Conversations
                            </Link>
                            <Link to="/user/proposals" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-3 text-sm flex items-center gap-2">
                              📝 Mes Devis
                            </Link>
                            <Link to="/user/invoices" onClick={() => setMobileMenuOpen(false)} className="bg-green-50 rounded-lg p-3 text-sm flex items-center gap-2 text-green-700">
                              📄 Mes Factures
                            </Link>
                            <Link to="/user/subscription" onClick={() => setMobileMenuOpen(false)} className="bg-blue-50 rounded-lg p-3 text-sm flex items-center gap-2">
                              💳 {i18n.language === 'fr' ? 'Mon Abonnement' : 'Subscription'}
                            </Link>
                            <Link to="/user/mes-annonces-talents" onClick={() => setMobileMenuOpen(false)} className="bg-[#00D4FF]/10 rounded-lg p-3 text-sm flex items-center gap-2 text-[#00D4FF]">
                              👷 {i18n.language === 'fr' ? 'Mes Talents' : 'My Talents'}
                            </Link>
                          </div>
                        </div>
                        
                        {/* Section Découverte/Pro - Pour les utilisateurs avec ces abonnements */}
                                                {(hasRole('decouverte') || hasRole('pro')) && !hasRole('supplier') && (
                                                  <div className="border-t pt-4 mb-4">
                                                    <p className="text-xs text-[#635BFF] uppercase mb-3 font-bold">📋 Mes Annonces</p>
                                                    <Link to="/user/mes-annonces" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-4 flex items-center gap-3 text-[#635BFF] font-medium">
                                                      <span className="text-2xl">📦</span>
                                                      <div>
                                                        <p className="font-bold">{i18n.language === 'fr' ? 'Gérer mes annonces' : 'Manage my ads'}</p>
                                                        <p className="text-xs text-gray-500">{hasRole('pro') ? 'Pack Pro - 3 annonces' : 'Pack Découverte - 1 annonce'}</p>
                                                      </div>
                                                    </Link>
                                                  </div>
                                                )}
                          
                        {(hasRole('supplier') || hasRole('admin')) && (
                          <>
                            {/* Espace Fournisseur - Compact */}
                            <div className="border-t pt-4 mb-4">
                              <p className="text-xs text-[#635BFF] uppercase mb-3 font-bold">🏭 Espace Fournisseur</p>
                              <div className="grid grid-cols-2 gap-2">
                                <Link to="/supplier/opportunities" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-3 text-sm text-[#635BFF]">
                                  🏗️ Chantiers
                                </Link>
                                <Link to="/supplier/my-products" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-3 text-sm text-[#635BFF]">
                                  📦 Produits
                                </Link>
                                <Link to="/supplier/my-rental-listings" onClick={() => setMobileMenuOpen(false)} className="bg-orange-50 rounded-lg p-3 text-sm text-[#00D4FF]">
                                  🚜 Locations
                                </Link>
                                <Link to="/supplier/rental-requests" onClick={() => setMobileMenuOpen(false)} className="bg-orange-50 rounded-lg p-3 text-sm text-[#00D4FF]">
                                  📋 Demandes
                                </Link>
                                <Link to="/supplier/orders" onClick={() => setMobileMenuOpen(false)} className="bg-blue-50 rounded-lg p-3 text-sm">
                                  📦 Commandes
                                </Link>
                                <Link to="/supplier/invoices" onClick={() => setMobileMenuOpen(false)} className="bg-green-50 rounded-lg p-3 text-sm text-green-700">
                                  📄 Factures
                                </Link>
                                <Link to="/supplier/product-quote-requests" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-3 text-sm text-[#635BFF]">
                                  📩 Devis
                                </Link>
                              </div>
                              <Link to="/supplier/my-quotes" onClick={() => setMobileMenuOpen(false)} className="bg-[#635BFF]/5 rounded-lg p-3 text-sm text-[#635BFF] col-span-2 mt-2">
                                📋 {i18n.language === 'fr' ? 'Mes Devis chantiers' : 'My project quotes'}
                              </Link>
                            </div>
                          </>
                        )}
                          
                        {hasRole('admin') && (
                          <div className="border-t pt-4 mb-4">
                            <p className="text-xs text-purple-600 uppercase mb-3 font-bold">👑 Administration</p>
                            <div className="grid grid-cols-3 gap-2">
                              <Link to="/admin" onClick={() => setMobileMenuOpen(false)} className="bg-purple-100 rounded-lg p-3 text-xs text-purple-700 text-center">
                                🏠 Dashboard
                              </Link>
                              <Link to="/admin/revenues" onClick={() => setMobileMenuOpen(false)} className="bg-green-100 rounded-lg p-3 text-xs text-green-700 text-center">
                                💰 Revenus
                              </Link>
                              <Link to="/admin/users" onClick={() => setMobileMenuOpen(false)} className="bg-purple-50 rounded-lg p-3 text-xs text-purple-700 text-center">
                                👥 Users
                              </Link>
                              <Link to="/admin/banners" onClick={() => setMobileMenuOpen(false)} className="bg-purple-50 rounded-lg p-3 text-xs text-purple-700 text-center">
                                📢 Bannières
                              </Link>
                              <Link to="/admin/rentals" onClick={() => setMobileMenuOpen(false)} className="bg-orange-50 rounded-lg p-3 text-xs text-orange-700 text-center">
                                🚜 Locations
                              </Link>
                              <Link to="/admin/moderation" onClick={() => setMobileMenuOpen(false)} className="bg-purple-50 rounded-lg p-3 text-xs text-purple-700 text-center">
                                ✅ Modération
                              </Link>
                              <Link to="/admin/subscriptions" onClick={() => setMobileMenuOpen(false)} className="bg-purple-50 rounded-lg p-3 text-xs text-purple-700 text-center">
                                💳 Abos
                              </Link>
                            </div>
                          </div>
                        )}

                        {/* Section Enchères pour acheteurs/vendeurs */}
                        {(user?.roles?.includes('enchere_acheteur') || user?.roles?.includes('enchere_vendeur')) && (
                          <div className="border-t pt-4 mb-4">
                            <p className="text-xs text-[#F0A22E] uppercase mb-3 font-bold">🔨 Enchères</p>
                            <div className="grid grid-cols-2 gap-2">
                              {user?.roles?.includes('enchere_acheteur') && (
                                <Link to="/encheres/mon-compte" onClick={() => setMobileMenuOpen(false)} className="bg-[#F0A22E]/10 rounded-lg p-3 text-sm text-[#F0A22E] text-center font-medium">
                                  🛒 Espace Acheteur
                                </Link>
                              )}
                              {user?.roles?.includes('enchere_vendeur') && (
                                <Link to="/encheres/espace-vendeur" onClick={() => setMobileMenuOpen(false)} className="bg-[#F0A22E]/10 rounded-lg p-3 text-sm text-[#F0A22E] text-center font-medium">
                                  🏷️ Espace Vendeur
                                </Link>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    
                    {/* Footer du menu */}
                    <div className="border-t pt-4 mt-4 flex justify-end items-center">
                      {user ? (
                        <button 
                          onClick={() => { logout(); setMobileMenuOpen(false); }} 
                          className="bg-red-100 text-red-600 px-4 py-2 rounded-lg"
                        >
                          {t('nav.logout')}
                        </button>
                      ) : (
                        <Link 
                          to="/login" 
                          onClick={() => setMobileMenuOpen(false)} 
                          className="bg-[#0A2540] text-white px-6 py-2 rounded-lg"
                        >
                          {t('nav.login')}
                        </Link>
                      )}
                    </div>
                  </nav>
                </div>
              )}
            </div>
          </header>

          {/* Value Proposition Banner */}
          <ValueBanner />

          {/* Main Content */}
          <main className="flex-1">
            {isLoading ? (
              <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#0A2540] mx-auto mb-4"></div>
                  <p className="text-gray-600">{t('loading')}</p>
                </div>
              </div>
            ) : (
            <Routes>
              <Route path="/" element={<HomeV2 />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/materiel" element={<Shop />} />
              <Route path="/materiel/:categorySlug" element={<ShopCategory />} />
              <Route path="/materiel/:categorySlug/:productSlug" element={<ProductDetail />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/product/:productId/conversation/:conversationId" element={user ? <ProductConversation /> : <Navigate to="/login" />} />
              <Route path="/cart" element={user ? <Cart /> : <Navigate to="/login" />} />
              <Route path="/checkout" element={user ? <Checkout /> : <Navigate to="/login" />} />
              <Route path="/order-confirmation/:orderId" element={user ? <OrderConfirmation /> : <Navigate to="/login" />} />
              <Route path="/rental" element={user ? <Rental /> : <Navigate to="/login" />} />
              <Route path="/rental/:id" element={user ? <RentalDetail /> : <Navigate to="/login" />} />
              <Route path="/rentals/conversations" element={user ? <RentalConversations /> : <Navigate to="/login" />} />
              <Route path="/rentals/conversations/:conversationId" element={user ? <RentalConversation /> : <Navigate to="/login" />} />
              <Route path="/stores" element={<Stores />} />
              <Route path="/directory" element={<DirectoryMain />} />
              <Route path="/annuaire" element={<DirectoryMain />} />
              <Route path="/annuaire/etalonnage-instrumentation-geotechnique" element={<EtalonnageInstrumentation />} />
              <Route path="/annuaire/:familySlug" element={<DirectoryFamily />} />
              <Route path="/annuaire/:familySlug/:categorySlug" element={<DirectoryCategoryOrCompany />} />
              <Route path="/directory/submit" element={<DirectorySubmit />} />
              <Route path="/annuaire/submit" element={<DirectorySubmit />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/tarifs" element={<Navigate to="/pricing" replace />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              
              {/* Service Request Forms (no auth required) */}
              <Route path="/vendre" element={<VendreMateriel />} />
              <Route path="/louer-mon-materiel" element={<LouerMateriel />} />
              <Route path="/service-technique" element={<ServiceTechnique />} />
              <Route path="/etude-geotechnique" element={<EtudeGeotechnique />} />
              <Route path="/travaux-fondations" element={<TravauxFondations />} />
              <Route path="/recrutement" element={<Recrutement />} />
              <Route path="/home-v2" element={<HomeV2 />} />
              
              {/* User Routes */}
              <Route path="/user/dashboard" element={user ? <UserDashboard /> : <Navigate to="/login" />} />
              <Route path="/user/subscription" element={user ? <MySubscription /> : <Navigate to="/login" />} />
              <Route path="/user/listings" element={user ? <MyListings /> : <Navigate to="/login" />} />
              <Route path="/user/invoices" element={user ? <MyInvoices /> : <Navigate to="/login" />} />
              <Route path="/user/orders" element={user ? <MyOrders /> : <Navigate to="/login" />} />
              <Route path="/user/orders/:orderId" element={user ? <UserOrderDetail /> : <Navigate to="/login" />} />
              <Route path="/user/rentals" element={user ? <MyRentals /> : <Navigate to="/login" />} />
              <Route path="/user/requests" element={user ? <MyRequests /> : <Navigate to="/login" />} />
              <Route path="/user/projects" element={user ? <MyProjects /> : <Navigate to="/login" />} />
              <Route path="/user/projects/:projectId" element={user ? <ProjectDetail /> : <Navigate to="/login" />} />
              <Route path="/user/proposals" element={user ? <MyProposals /> : <Navigate to="/login" />} />
              <Route path="/user/proposals/:quoteId" element={user ? <ProposalThread /> : <Navigate to="/login" />} />
              <Route path="/user/conversations" element={user ? <AllConversations /> : <Navigate to="/login" />} />
              <Route path="/user/my-annonce" element={user ? <MyAnnonce /> : <Navigate to="/login" />} />
              <Route path="/user/mes-annonces" element={user ? <MyAnnonces /> : <Navigate to="/login" />} />
              <Route path="/user/mes-annonces-talents" element={user ? <MyTalentAds /> : <Navigate to="/login" />} />
              
              {/* Talents & Recrutement Routes */}
              <Route path="/talents" element={<Talents />} />
              <Route path="/talents/publier" element={user ? <TalentPublish /> : <Navigate to="/login" />} />
              <Route path="/talents/:id" element={<TalentDetail />} />
              
              {/* Technical Comparator */}
              <Route path="/comparateur" element={<Comparator />} />
              
              {/* Supplier Routes (accessible to suppliers and admins) */}
              <Route path="/supplier/opportunities" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierOpportunities /> : <Navigate to="/" />} />
              <Route path="/supplier/rfq/:projectId" element={(hasRole('supplier') || hasRole('admin')) ? <ProjectRFQ /> : <Navigate to="/" />} />
              <Route path="/supplier/my-products" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierMyProducts /> : <Navigate to="/" />} />
              <Route path="/supplier/my-rental-listings" element={(hasRole('supplier') || hasRole('admin')) ? <MyRentalListings /> : <Navigate to="/" />} />
              <Route path="/supplier/rental-requests" element={(hasRole('supplier') || hasRole('admin') || hasRole('decouverte')) ? <RentalRequests /> : <Navigate to="/" />} />
              <Route path="/supplier/orders" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierOrders /> : <Navigate to="/" />} />
              <Route path="/supplier/orders/:orderId" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierOrderDetail /> : <Navigate to="/" />} />
              <Route path="/supplier/invoices" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierInvoices /> : <Navigate to="/" />} />
              <Route path="/supplier/orders" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierOrders /> : <Navigate to="/" />} />
              <Route path="/supplier/product-quote-requests" element={(hasRole('supplier') || hasRole('admin')) ? <ProductQuoteRequests /> : <Navigate to="/" />} />
              <Route path="/supplier/my-quotes" element={(hasRole('supplier') || hasRole('admin')) ? <MyQuotes /> : <Navigate to="/" />} />
              <Route path="/supplier/submit-quote/:projectId" element={(hasRole('supplier') || hasRole('admin')) ? <SubmitQuote /> : <Navigate to="/" />} />
              <Route path="/supplier/quotes/:quoteId" element={(hasRole('supplier') || hasRole('admin')) ? <SupplierQuoteThread /> : <Navigate to="/" />} />
              
              {/* Public Requests */}
              <Route path="/requests" element={<Requests />} />
              <Route path="/requests/:id" element={user ? <RequestDetail /> : <Navigate to="/login" />} />
              <Route path="/requests/conversations/:conversationId" element={user ? <RequestConversation /> : <Navigate to="/login" />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={hasRole('admin') ? <AdminDashboard /> : <Navigate to="/" />} />
              <Route path="/admin/banners" element={hasRole('admin') ? <AdminBanners /> : <Navigate to="/" />} />
              <Route path="/admin/quote-requests" element={hasRole('admin') ? <AdminQuoteRequests /> : <Navigate to="/" />} />
              <Route path="/admin/request-approvals" element={hasRole('admin') ? <RequestApprovals /> : <Navigate to="/" />} />
              <Route path="/admin/requests-management" element={hasRole('admin') ? <RequestsManagement /> : <Navigate to="/" />} />
              <Route path="/admin/user-approvals" element={hasRole('admin') ? <UserApprovals /> : <Navigate to="/" />} />
              <Route path="/admin/users" element={hasRole('admin') ? <UsersManagement /> : <Navigate to="/" />} />
              <Route path="/admin/directory-categories" element={hasRole('admin') ? <AdminDirectoryCategories /> : <Navigate to="/" />} />
              <Route path="/admin/directory-pending" element={hasRole('admin') ? <AdminDirectoryPending /> : <Navigate to="/" />} />
              <Route path="/admin/directory-management" element={hasRole('admin') ? <AdminDirectoryManagement /> : <Navigate to="/" />} />
              <Route path="/admin/directory-import" element={hasRole('admin') ? <DirectoryImport /> : <Navigate to="/" />} />
              {/* <Route path="/admin/premium-management" element={hasRole('admin') ? <PremiumManagement /> : <Navigate to="/" />} /> */}
              <Route path="/admin/products" element={hasRole('admin') ? <AdminProducts /> : <Navigate to="/" />} />
              <Route path="/admin/categories" element={hasRole('admin') ? <AdminCategories /> : <Navigate to="/" />} />
              <Route path="/admin/orders" element={hasRole('admin') ? <AdminOrders /> : <Navigate to="/" />} />
              <Route path="/admin/rentals" element={hasRole('admin') ? <AdminRentals /> : <Navigate to="/" />} />
              <Route path="/admin/rental-approvals" element={hasRole('admin') ? <RentalApprovals /> : <Navigate to="/" />} />
              <Route path="/admin/rental-messages" element={hasRole('admin') ? <AdminRentalMessages /> : <Navigate to="/" />} />
              <Route path="/admin/reviews" element={hasRole('admin') ? <AdminReviews /> : <Navigate to="/" />} />
              <Route path="/admin/shops" element={hasRole('admin') ? <AdminShops /> : <Navigate to="/" />} />
              <Route path="/admin/revenues" element={hasRole('admin') ? <AdminRevenues /> : <Navigate to="/" />} />
              <Route path="/admin/product-approvals" element={hasRole('admin') ? <ProductApprovals /> : <Navigate to="/" />} />
              <Route path="/admin/directory" element={hasRole('admin') ? <AdminDirectory /> : <Navigate to="/" />} />
              <Route path="/admin/moderation" element={hasRole('admin') ? <AdminModeration /> : <Navigate to="/" />} />
              <Route path="/admin/users" element={hasRole('admin') ? <AdminUsers /> : <Navigate to="/" />} />
              <Route path="/admin/content-violations" element={hasRole('admin') ? <ContentViolations /> : <Navigate to="/" />} />
              <Route path="/admin/subscriptions" element={hasRole('admin') ? <SubscriptionManagement /> : <Navigate to="/" />} />
              <Route path="/admin/security" element={hasRole('admin') ? <SecurityDashboard /> : <Navigate to="/" />} />
              <Route path="/admin/talents" element={hasRole('admin') ? <AdminTalents /> : <Navigate to="/" />} />
              <Route path="/admin/comparator" element={hasRole('admin') ? <AdminComparator /> : <Navigate to="/" />} />
              <Route path="/admin/comparator/:productId" element={hasRole('admin') ? <AdminComparatorSpecs /> : <Navigate to="/" />} />
              <Route path="/admin/templates" element={hasRole('admin') ? <AdminTemplates /> : <Navigate to="/" />} />
              <Route path="/admin/templates/:templateId/fields" element={hasRole('admin') ? <TemplateFields /> : <Navigate to="/" />} />
              <Route path="/admin/demandes" element={hasRole('admin') ? <DemandesDashboard /> : <Navigate to="/" />} />
              <Route path="/admin/annonces" element={hasRole('admin') ? <AdminAnnonces /> : <Navigate to="/" />} />
              <Route path="/admin/stats" element={hasRole('admin') ? <AdminStats /> : <Navigate to="/" />} />
              <Route path="/admin/encheres" element={hasRole('admin') ? <AdminEncheres /> : <Navigate to="/" />} />
              
              <Route path="/admin/users/:userId/history" element={hasRole('admin') ? <AdminUserHistory /> : <Navigate to="/" />} />
              
              {/* User Verification */}
              <Route path="/user/verification" element={user ? <UserVerification /> : <Navigate to="/login" />} />
              
              {/* Legal Pages - Public routes */}
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/legal-notice" element={<LegalNotice />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/comment-ca-marche" element={<HowItWorks />} />
              <Route path="/guides" element={<GuidesIndex />} />
              <Route path="/guides/categorie/:categorySlug" element={<GuideCategoryPage />} />
              
              {/* Enchères Module - Vente par courtage aux enchères */}
              <Route path="/encheres" element={<EncheresHub />} />
              <Route path="/encheres/conditions" element={<EncheresConditions />} />
              <Route path="/encheres/devenir-vendeur" element={<DevenirVendeur />} />
              <Route path="/encheres/connexion" element={<EncheresConnexion />} />
              <Route path="/encheres/mon-compte" element={<MonCompteAcheteur />} />
              <Route path="/encheres/espace-vendeur" element={<EspaceVendeur />} />
              <Route path="/encheres/:vacationSlug" element={<VacationPage />} />
              <Route path="/encheres/:vacationSlug/inscription" element={<InscriptionVacation />} />
              <Route path="/encheres/:vacationSlug/:lotSlug" element={<LotPage />} />
              
              <Route path="/calcul" element={<CalculsIndex />} />
              <Route path="/calcul/portance-micropieu" element={<PortanceMicropieu />} />
              <Route path="/calcul/estimer-ma-foreuse" element={<EstimerForeuse />} />
              <Route path="/calcul/prix-etude-de-sol" element={<PrixEtudeSol />} />
              <Route path="/guides/comment-choisir-foreuse-geotechnique" element={<HowToChooseDrilling />} />
              <Route path="/guides/comment-choisir-etude-geotechnique" element={<HowToChooseGeotechnicalStudy />} />
              <Route path="/guides/comment-choisir-fondations-speciales" element={<HowToChooseSpecialFoundations />} />
              <Route path="/guides/paroi-moulee-technique-realisation" element={<SlurryWallGuide />} />
              <Route path="/guides/materiel-de-forage" element={<DrillingEquipmentGuide />} />
              <Route path="/guides/fissures-maison-quand-s-inquieter" element={<HouseCracksGuide />} />
              <Route path="/guides/enregistreur-parametres-forage" element={<DrillParameterRecorderGuide />} />
              <Route path="/guides/micropieux" element={<MicropieuxGuide />} />
              <Route path="/guides/essai-pressiometrique-menard" element={<PressiometricTestGuide />} />
              <Route path="/guides/injection-coulis-traitement-de-sol" element={<InjectionGuide />} />
              <Route path="/guides/foreuse-occasion-micropieux" element={<ForeuseOccasionMicropieuxGuide />} />
              <Route path="/guides/choisir-pressiometre-manuel-automatique" element={<PressiometreChoixGuide />} />
              <Route path="/guides/metier-foreur-sondeur" element={<MetierForeurSondeurGuide />} />
              <Route path="/guides/prix-forage-eau" element={<PrixForageEauGuide />} />
              <Route path="/guides/etalonnage-capteurs-forage" element={<EtalonnageCapteurs />} />
              <Route path="/forage-eau/demande" element={<ForageEauDemande />} />
              <Route path="/rachat/visite" element={<DemandeVisite />} />
              <Route path="/materiel/demande" element={<MaterielDemande />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/commissions" element={<Commissions />} />
              <Route path="/inscription" element={<Inscription />} />
              <Route path="/mon-compte" element={<MonCompte />} />
            </Routes>
            )}
          </main>

          {/* Footer */}
          <Footer />

          {/* WhatsApp Float Button */}
          <a 
            href="https://wa.me/33782939383" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-float"
            data-testid="whatsapp-button"
          >
            <FaWhatsapp />
          </a>

          <Toaster position="top-right" />
          <CookieConsentBanner />
          
          {/* Comparator Global Components */}
          <ComparatorFloatingBar />
          <ComparatorCategoryErrorModal />
        </div>
      </BrowserRouter>
      </ComparatorProvider>
    </AppContext.Provider>
  );
}

export default App;